import React from 'react';
import { Link } from 'react-router-dom';
import V3Header from '../components/V3Header';
import V3Footer from '../components/V3Footer';
import { useLanguage } from '../LanguageContext';
import '../V3.css';

const V3LeadershipDevelopment = () => {
  const { t, lang } = useLanguage();
  const steps = t('leadership.steps');

  return (
    <div className="v3-app">
      <div className="v3-page">
        <V3Header activeNav="leadership" />
        <div className={`v3-hero ${lang === 'hi' ? 'right' : ''}`}>
          <div className="v3-tag-eyebrow">{t('common.vertical01')}</div>
          <h1>{t('leadership.title')}</h1>
          <p>{t('leadership.intro')}</p>
        </div>

        <section className="v3-block">
          <h2>{t('leadership.howTitle')}</h2>
          <div className="v3-grid4">
            {Array.isArray(steps) && steps.map(({ title, desc }, i) => (
              <div key={title} className="v3-step">
                <div className="v3-num">{i + 1}</div>
                <strong style={{ fontSize: 13 }}>{title}</strong>
                {desc && <p style={{ fontSize: 12, margin: '6px 0 0', color: '#555' }}>{desc}</p>}
              </div>
            ))}
          </div>
        </section>

        <section className="v3-block">
          <h2>{t('leadership.criteriaTitle')}</h2>
          <div className="v3-grid2">
            <div className="v3-wire-block">
              <h3 style={{ marginTop: 0 }}>{t('leadership.writtenExam')}</h3>
              <ul className="v3-wire-list">
                {t('leadership.writtenItems').map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>
            <div className="v3-wire-block">
              <h3 style={{ marginTop: 0 }}>{t('leadership.interview')}</h3>
              <ul className="v3-wire-list">
                {t('leadership.interviewItems').map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>
          </div>
        </section>

        <div className="v3-cta-strip">
          <div className="v3-btn-row" style={{ marginTop: 0 }}>
            <Link to="/apply" className="v3-btn">{t('common.becomeCandidate')}</Link>
            <Link to="/sponsor-a-program" className="v3-btn">{t('common.becomeSponsor')}</Link>
          </div>
        </div>
        <V3Footer />
      </div>
    </div>
  );
};

export default V3LeadershipDevelopment;
